import { object, string, number, mixed, array } from 'yup';
import { VoucherStatus, VoucherType } from '../../models/vouchers';
import { checkIsraeliPhone } from '../helpers';
import { emptyValueCheck } from './customValidations';
import { CONSTANTS } from '../constants';

// Validation for ManageVouchers search filters
export const vouchersListSearchValidation = object().shape({
  code: string(),
  status: number()
    .transform(emptyValueCheck)
    .nullable()
    .test(
      'valid-status',
      'סטטוס לא תקין',
      (value) => value == null || Object.values(VoucherStatus).includes(value)
    ),
  type: number()
    .transform(emptyValueCheck)
    .nullable()
    .test(
      'valid-type',
      'סוג לא תקין',
      (value) => value == null || Object.values(VoucherType).includes(value)
    ),
  siteId: number().transform(emptyValueCheck).nullable(),
  customerPhoneNumber: string().test(
    'check phone number',
    'מספר הפלאפון לא תקין',
    (value) => {
      return value ? checkIsraeliPhone(value) : true;
    }
  ),
  createdBy: string(),
  voucherId: number().transform(emptyValueCheck).nullable(),
  fromDate: mixed().test('check fromDate value', function (value) {
    const toDate = this.parent.toDate;
    if (!value || !toDate) return true;
    return new Date(value) > new Date(toDate)
      ? this.createError({ message: 'טווח התאריכים שגוי', path: 'fromDate' })
      : true;
  }),
  toDate: mixed().test('check toDate value', function (value) {
    const fromDate = this.parent.fromDate;
    if (!value) return true;
    if (fromDate) {
      return new Date(value) < new Date(fromDate)
        ? this.createError({ message: 'טווח התאריכים שגוי', path: 'toDate' })
        : true;
    }
    return true;
  }),
});

export default vouchersListSearchValidation;

// Validation for VoucherDetails (Add)
export const vouchersDetailsAddValidation = object({
  type: number()
    .typeError(CONSTANTS.VALIDATION_ERRORS.REQUIRED)
    .required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
  siteId: number()
    .typeError(CONSTANTS.VALIDATION_ERRORS.REQUIRED)
    .required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
  expiryDate: string()
    .typeError(CONSTANTS.VALIDATION_ERRORS.REQUIRED)
    .required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
  phoneNumbers: array().of(string()).nullable(),
});

export const vouchersDetailsAddChildrenPhoneNumberValidation = {
  childValidator: (v: string) => checkIsraeliPhone(v),
  childInvalidMessage: 'מספר הפלאפון לא תקין',
};

// Validation for VoucherDetails (Edit)
export const vouchersDetailsEditValidation = object({
  siteId: number()
    .typeError(CONSTANTS.VALIDATION_ERRORS.REQUIRED)
    .required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
  expiryDate: string()
    .typeError(CONSTANTS.VALIDATION_ERRORS.REQUIRED)
    .required(CONSTANTS.VALIDATION_ERRORS.REQUIRED),
  customerPhoneNumber: string()
    .nullable()
    .test('check phone number', 'מספר הפלאפון לא תקין', (value) => {
      return value ? checkIsraeliPhone(value) : true;
    }),
});
